/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Prop_P1_AfterInputs */

const es_cap_prop_p1_after = /** @type {(inputs: Cap_Prop_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const gl_cap_prop_p1_after = /** @type {(inputs: Cap_Prop_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const en_cap_prop_p1_after = /** @type {(inputs: Cap_Prop_P1_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Cap_Prop_P1_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_prop_p1_after = /** @type {((inputs?: Cap_Prop_P1_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Prop_P1_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_prop_p1_after(inputs)
	if (locale === "en") return en_cap_prop_p1_after(inputs)
	return es_cap_prop_p1_after(inputs)
});